<template>
  <!-- Page Content -->
  <div id="page-wrapper">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12">
          <p class="page-header lead"><i class="fa fa-user"></i> {{ email }}</p>
        </div>
        <!-- /.col-lg-12 -->
      </div>
      <!-- /.row -->
      <div class="row">
        <div class="col-lg-3 col-md-6">
          <div class="panel panel-primary">
            <div class="panel-heading">
              <div class="row">
                <div class="col-xs-3">
                  <i class="fa fa-gear fa-4x"></i>
                </div>
                <div class="col-xs-9 text-right">
                  <div>Периферия</div>
                </div>
              </div>
            </div>
            <router-link to="/peripherals">
              <div class="panel-footer">
                <span class="pull-left">Подробнее</span>
                <span class="pull-right"><i class="fa fa-arrow-circle-right"></i></span>
                <div class="clearfix"></div>
              </div>
            </router-link>
          </div>
        </div>
        <div class="col-lg-3 col-md-6">
          <div class="panel panel-primary">
            <div class="panel-heading">
              <div class="row">
                <div class="col-xs-3">
                  <i class="fa fa-gears fa-4x"></i>
                </div>
                <div class="col-xs-9 text-right">
                  <div>Детали</div>
                </div>
              </div>
            </div>
            <router-link to="/details">
              <div class="panel-footer">
                <span class="pull-left">Подробнее</span>
                <span class="pull-right"><i class="fa fa-arrow-circle-right"></i></span>
                <div class="clearfix"></div>
              </div>
            </router-link>
          </div>
        </div>
        <div class="col-lg-3 col-md-6">
          <div class="panel panel-primary">
            <div class="panel-heading">
              <div class="row">
                <div class="col-xs-3">
                  <i class="fa fa-sitemap fa-4x"></i>
                </div>
                <div class="col-xs-9 text-right">
                  <div>Платы</div>
                </div>
              </div>
            </div>
            <router-link to="/circuit_boards">
              <div class="panel-footer">
                <span class="pull-left">Подробнее</span>
                <span class="pull-right"><i class="fa fa-arrow-circle-right"></i></span>
                <div class="clearfix"></div>
              </div>
            </router-link>
          </div>
        </div>
        <div class="col-lg-3 col-md-6">
          <div class="panel panel-primary">
            <div class="panel-heading">
              <div class="row">
                <div class="col-xs-3">
                  <i class="fa fa-folder fa-4x"></i>
                </div>
                <div class="col-xs-9 text-right">
                  <div>Проекты</div>
                </div>
              </div>
            </div>
            <router-link to="/projects">
              <div class="panel-footer">
                <span class="pull-left">Подробнее</span>
                <span class="pull-right"><i class="fa fa-arrow-circle-right"></i></span>
                <div class="clearfix"></div>
              </div>
            </router-link>
          </div>
        </div>
        <div class="col-lg-3 col-md-6">
          <div class="panel panel-primary">
            <div class="panel-heading">
              <div class="row">
                <div class="col-xs-3">
                  <i class="fa fa-files-o fa-4x"></i>
                </div>
                <div class="col-xs-9 text-right">
                  <div>Наряд-заказы</div>
                </div>
              </div>
            </div>
            <router-link to="/orders">
              <div class="panel-footer">
                <span class="pull-left">Подробнее</span>
                <span class="pull-right"><i class="fa fa-arrow-circle-right"></i></span>
                <div class="clearfix"></div>
              </div>
            </router-link>
          </div>
        </div>
        <div class="col-lg-3 col-md-6">
          <div class="panel panel-primary">
            <div class="panel-heading">
              <div class="row">
                <div class="col-xs-3">
                  <i class="fa fa-users fa-4x"></i>
                </div>
                <div class="col-xs-9 text-right">
                  <div>Поставщики</div>
                </div>
              </div>
            </div>
            <router-link to="/providers">
              <div class="panel-footer">
                <span class="pull-left">Подробнее</span>
                <span class="pull-right"><i class="fa fa-arrow-circle-right"></i></span>
                <div class="clearfix"></div>
              </div>
            </router-link>
          </div>
        </div>
        <div class="col-lg-3 col-md-6">
          <div class="panel panel-primary">
            <div class="panel-heading">
              <div class="row">
                <div class="col-xs-3">
                  <i class="fa fa-users fa-4x"></i>
                </div>
                <div class="col-xs-9 text-right">
                  <div>Клиенты</div>
                </div>
              </div>
            </div>
            <router-link to="/clients">
              <div class="panel-footer">
                <span class="pull-left">Подробнее</span>
                <span class="pull-right"><i class="fa fa-arrow-circle-right"></i></span>
                <div class="clearfix"></div>
              </div>
            </router-link>
          </div>
        </div>
        <div class="col-lg-3 col-md-6">
          <div class="panel panel-primary">
            <div class="panel-heading">
              <div class="row">
                <div class="col-xs-3">
                  <i class="fa fa-user fa-4x"></i>
                </div>
                <div class="col-xs-9 text-right">
                  <div>Пользователи</div>
                </div>
              </div>
            </div>
            <router-link to="/users">
              <div class="panel-footer">
                <span class="pull-left">Подробнее</span>
                <span class="pull-right"><i class="fa fa-arrow-circle-right"></i></span>
                <div class="clearfix"></div>
              </div>
            </router-link>
          </div>
        </div>
        <div class="col-lg-3 col-md-6">
          <div class="panel panel-primary">
            <div class="panel-heading">
              <div class="row">
                <div class="col-xs-3">
                  <i class="fa fa-arrows-h fa-4x"></i>
                </div>
                <div class="col-xs-9 text-right">
                  <div>Движение по складу</div>
                </div>
              </div>
            </div>
            <router-link to="/stock_movement">
              <div class="panel-footer">
                <span class="pull-left">Подробнее</span>
                <span class="pull-right"><i class="fa fa-arrow-circle-right"></i></span>
                <div class="clearfix"></div>
              </div>
            </router-link>
          </div>
        </div>
        <div class="col-lg-3 col-md-6">
          <div class="panel panel-primary">
            <div class="panel-heading">
              <div class="row">
                <div class="col-xs-3">
                  <i class="fa fa-file-text-o fa-4x"></i>
                </div>
                <div class="col-xs-9 text-right">
                  <div>Инвентаризация</div>
                </div>
              </div>
            </div>
            <router-link to="/inventory">
              <div class="panel-footer">
                <span class="pull-left">Подробнее</span>
                <span class="pull-right"><i class="fa fa-arrow-circle-right"></i></span>
                <div class="clearfix"></div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useTokenPayload } from '@/mixins';
export default {
  mixins: [
    useTokenPayload,
  ],
}
</script>



// WEBPACK FOOTER //
// src/pages/Main.vue